/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionType, TargetType } from 'types/generalType';

export default function ({
  ActionType,
  TargetType,
  GatewayOperationType,
  SourceWallet,
  BrandUnikID,
  ShortName,
  Amount,
  TargetCountryCode,
  Category,
  DestType,
  AccountNumber,
  SourceType,
  PartnerRequest,
  SendVoucher,
  TargetAccountNumber,
  TargetPhoneNumber,
  ContactPID,
  otherKeys,
  OTP,
  SelfieURL,
  description,
}: {
  ActionType: ActionType | any;
  TargetType: TargetType | any;
  GatewayOperationType: string;
  SourceWallet?: string;
  BrandUnikID?: string;
  ShortName?: string;
  Amount: string;
  TargetCountryCode?: string;
  Category?: string;
  DestType?: string;
  AccountNumber?: string;
  SourceType?: string;
  PartnerRequest?: any;
  SendVoucher?: string;
  TargetAccountNumber?: string;
  TargetPhoneNumber?: string;
  ContactPID?: string;
  otherKeys?: any;
  OTP?: string;
  SelfieURL?: string;
  description?: string;
}) {
  return {
    ActionType,
    TargetType,
    GatewayOperationType,
    SourceWallet,
    BrandUnikID,
    ShortName,
    Amount,
    TargetCountryCode,
    Category,
    DestType,
    AccountNumber,
    SourceType,
    PartnerRequest,
    SendVoucher,
    TargetAccountNumber,
    TargetPhoneNumber,
    ContactPID,
    OTP,
    SelfieURL,
    description,
    ...otherKeys,
  };
}
